import React from 'react';
import calendarCheckIcon from '../../assets/icons/calendar-check.svg';
import calendarClockIcon from '../../assets/icons/calendar-clock.svg';
import dollarIcon from '../../assets/icons/dollar.svg';

interface TreatmentEstimateProps {
    suggestedFees: string;
    duration: string;
    appointments: string;
}

const TreatmentEstimates: React.FC<TreatmentEstimateProps> = ({
    suggestedFees,
    duration,
    appointments
}) => {
    const estimates = [
        {
            icon: dollarIcon,
            label: 'Suggested Fees',
            value: suggestedFees ?? 'N/A'
        },
        {
            icon: calendarClockIcon,
            label: 'Duration',
            value: duration
        },
        {
            icon: calendarCheckIcon,
            label: '# of Appointments',
            value: appointments
        }
    ];

    return (
        <div className="bg-blue-50 rounded-xl p-6 w-full h-full flex flex-col justify-center">
            <h1 className="text-lg font-bold text-gray-800 mb-8">Treatment estimates</h1>
            <div className="flex flex-col gap-4">
                {estimates.map((estimate, index) => (
                    <div key={index} className="grid grid-cols-2 items-center gap-12">
                        <div className="flex items-center gap-3">
                            <img src={estimate.icon} alt="" className="w-5 h-5" />
                            <span className="font-bold text-sm text-gray-800">
                                {estimate.label}
                            </span>
                        </div>
                        <span className="text-base text-gray-800 justify-self-start">
                            {estimate.value}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TreatmentEstimates;
